function isString(val){
  return typeof val === 'string'
}
function isBool(val){
  return typeof val === 'boolean'
}

function empty(val){
  let type = typeof val
  switch (type){
    case 'string':
      return val === ''
    case 'number':
      return val <= 0
    case 'boolean':
      return !val
    case 'undefined':
      return true
    case 'object':
      return val === null
    default:
      return false
  }
}

export {isString,empty,isBool}